import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api';

/**
 * Génère ou récupère un visitor_id stable (UUID) stocké dans localStorage.
 * Utilisé pour identifier un même visiteur à travers ses sessions
 * (sans nécessiter de connexion).
 */
function getVisitorId() {
  let vid = localStorage.getItem('mc_visitor_id');
  if (!vid) {
    // simple UUID v4 minimal
    vid = 'v_' + ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
    localStorage.setItem('mc_visitor_id', vid);
  }
  return vid;
}

/**
 * Hook qui logue une vue de page à chaque changement de route.
 * - Ignore les routes /admin/* (pour ne pas polluer les stats avec le back-office)
 * - Throttle 2s pour éviter les double-comptages (StrictMode, redirections)
 */
export function usePageViewTracker() {
  const location = useLocation();
  const lastTrackedRef = useRef({ path: null, ts: 0 });

  useEffect(() => {
    const path = location.pathname;
    // Exclure les pages admin (privées, biaiseraient les stats)
    if (path.startsWith('/admin')) return;

    const now = Date.now();
    const last = lastTrackedRef.current;
    // Anti-doublon : 2 secondes de cooldown sur le même path
    if (last.path === path && now - last.ts < 2000) return;
    lastTrackedRef.current = { path, ts: now };

    const vid = getVisitorId();
    api.trackView(vid, path);
  }, [location.pathname]);
}
